// extracted by mini-css-extract-plugin
export default {"container":"MovingGradientCover_container__NkjHn","moving-gradient":"MovingGradientCover_moving-gradient__9qg+g"};